import { useSdk } from '~/sdk';

export const useProducts = () => {
  const key = useKey();
  const state = useState<{
    data: any;
    loading: boolean;
  }>(`${key.value}-products`, () => ({
    data: null,
    loading: false,
  }));

  const fetchProducts: FetchProducts = async (params: any) => {
    state.value.loading = true;
    const route = useRoute();

    const { id, slug } = params || useProductParams();

    const data = await useSdk().commerce.getProducts({
      id_category: id,
      categorySlug: slug,
      q: route?.query?.q || '',
      order: route.query.order || 'product.position.asc',
      page: route?.query?.page || 1,
    });

    state.value.data = data;
    state.value.loading = false;

    return data;
  };

  return {
    fetchProducts,
    ...toRefs(state.value),
  };
};
